import { render, staticRenderFns } from "./CustomerProfile.vue?vue&type=template&id=1dc732fe&scoped=true"
import script from "./CustomerProfile.vue?vue&type=script&lang=js"
export * from "./CustomerProfile.vue?vue&type=script&lang=js"
import style0 from "./CustomerProfile.vue?vue&type=style&index=0&id=1dc732fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc732fe",
  null
  
)

export default component.exports